import * as React from "react";
import JSONTree from 'react-json-tree';
import ObjectPath from "object-path";
import flat from "flat";
import { v4 as uuidv4 } from 'uuid';
import Highlighter from "react-highlight-words";

import FilterCheck from "./FilterCheck";
import MetamodelStore from "../../resources/data/MetamodelStore";
import FilterSearch from "./FilterSearch";
import Config from "../../Config";
import ModalRelationData from "../modals/ModalRelationData";
import JsonTreeCommons from "../../utils/JsonTreeCommons";
import StateGlobal from "../../StateGlobal";

/**
 * Filter attributes from the notebook
 */
export default class FilterCheckNotebook extends FilterCheck
{
    constructor(props)
    {
        super(props);

        this.aFilterSearchRef = React.createRef();
        this.aModalRel = React.createRef();

        this.state.sTreeKey = uuidv4();
        this.state.allObjects = [];
        this.state.allModels = [];
    }

    aTreeTheme = {
        base00: '#FFFFFF',
        base01: '#000000',
        base02: '#000000',
        base03: '#000000',
        base04: '#000000',
        base05: '#000000',
        base06: '#000000',
        base07: '#000000',
        base08: '#000000',
        base09: '#000000',
        base0A: '#000000',
        base0B: '#000000',
        base0C: '#000000',
        base0D: '#000000',
        base0E: '#000000',
        base0F: '#000000'
    };

    refreshSearch = () =>
    {
        this.state.sTreeKey = uuidv4();
        this.setState({});
    }

    getRelationSelection = () =>
    {
        let aRelationSelection = this.aModalRel.current.getFilterSelection();
        // console.log("aRelationSelection", aRelationSelection ? JSON.parse(JSON.stringify(aRelationSelection)) : null);
        aRelationSelection.forEach((aRelSelect) =>
        {
            let aExtra;
            if (aRelSelect.hasOwnProperty("extra"))
            {
                aExtra = aRelSelect.extra;
            } else if (aRelSelect.isPair)
            {
                aExtra = aRelSelect
            }
            this.handleChange(
                {
                    target: {
                        name: aRelSelect.name,
                        checked: true
                    }
                },
                aExtra
            );
        });
        this.props.onChangeCallback();
    }

    render()
    {
        const aNotebook = JSON.parse(JSON.stringify(this.props.aNotebook));
        const { bIsModelObj, onChangeCallback } = this.props;
        const bPreventRelationNotebook = this.props.preventRelationNotebook;

        var aTreeValsToSearch = flat.flatten(aNotebook);
        if (aTreeValsToSearch)
        {
            aTreeValsToSearch = Object.keys(aTreeValsToSearch);
        }
        var sSearchInput = this.aFilterSearchRef.current ? this.aFilterSearchRef.current.getSearchInput() : null;

        if (this.state.aDefaultSelected)
        {
            for (let i = 0; this.state.aDefaultSelected.length; i++)
            {
                this.handleChange(
                    {
                        target: {
                            name: this.state.aDefaultSelected[i].name,
                            checked: true
                        }
                    },
                    {
                        sType: this.state.aDefaultSelected[i].sType,
                        bIsModelObj: bIsModelObj
                    }
                );
                this.state.aDefaultSelected.splice(i, 1);
            }
        }

        return (
            <div>
                {aNotebook &&
                    <div>
                        <FilterSearch
                            aValsToSearch={aTreeValsToSearch}
                            aExclusions={["id_group", "chapter_name", "sName", "sType"]}
                            resultsReadyCallback={this.refreshSearch}
                            ref={this.aFilterSearchRef}
                            sSearchPlaceholderTxt={Config.strings.jsonTree.search.filterNotebook.searchPlaceholder}
                            sSearchIndicatorTxt={Config.strings.jsonTree.search.filterNotebook.searchingIndicator}
                            sSearchNoResultsTxt={Config.strings.jsonTree.search.filterNotebook.searchNoResults}
                        />
                        <JSONTree
                            key={this.state.sTreeKey}
                            data={aNotebook}
                            hideRoot={true}
                            theme={{
                                extend: this.aTreeTheme,
                                arrowSign: {
                                    fontFamily: "Segoe UI Symbol, sansSerif",
                                    color: "#AFAFAF"
                                },
                                tree: {
                                    fontSize: "12px"
                                }
                            }}
                            invertTheme={false}
                            getItemString={() => { return null }}
                            postprocessValue={(value) =>
                            {
                                if (Object.hasOwnProperty.call(value, 'chapter_name'))
                                {
                                    delete value['chapter_name'];
                                }
                                if (Object.hasOwnProperty.call(value, 'sType'))
                                {
                                    delete value['sType'];
                                }
                                if (Object.hasOwnProperty.call(value, 'id_group'))
                                {
                                    delete value['id_group'];
                                }
                                if (Object.hasOwnProperty.call(value, 'sName'))
                                {
                                    const sName = value.sName;
                                    value = sName;
                                }
                                return value;
                            }}
                            shouldExpandNode={(keyPath) =>
                            {
                                if (this.aFilterSearchRef.current)
                                {
                                    keyPath.reverse();
                                    var sKeyPathFlat = keyPath.join('.');
                                    keyPath.reverse();

                                    var bCheck = this.aFilterSearchRef.current.checkSearch(sKeyPathFlat);
                                    return bCheck;
                                }
                                return false;
                            }}
                            labelRenderer={(keyPath) =>
                            {
                                const sLabel = keyPath[0];
                                keyPath.reverse();
                                const aValue = ObjectPath.get(this.props.aNotebook, keyPath);
                                const aTopLvlVal = ObjectPath.get(this.props.aNotebook, keyPath[0]);
                                keyPath.reverse();
                                var sName = null;
                                var bCheckbox = false;
                                var bChecked = false;
                                var sType = 'ATTR';

                                keyPath.reverse();
                                const aInitData = ObjectPath.get(this.props.aNotebook, keyPath);
                                keyPath.reverse();
                                if (aInitData && Object.hasOwnProperty.call(aInitData, 'id_group'))
                                {
                                    try
                                    {
                                        var sIcon = MetamodelStore.getInstance().getIcon(aInitData.id_group);
                                    } catch (err)
                                    {
                                        console.warn(err);
                                    }
                                }

                                if (!aValue.hasOwnProperty("direction") && aValue && typeof aValue === 'object' && Object.hasOwnProperty.call(aValue, 'sName'))
                                {
                                    sName = aValue.sName;
                                    bCheckbox = true;
                                    if (Object.hasOwnProperty.call(aValue, 'sType'))
                                    {
                                        sType = aValue.sType;
                                    }
                                } else
                                {
                                    sName = keyPath[0];
                                }

                                if (undefined != this.state.aSelectedItems.find(aItem => (Object.hasOwnProperty.call(aItem, 'name') && aItem.name === sName)))
                                {
                                    bChecked = true;
                                }

                                if (bCheckbox)
                                {
                                    return (
                                        <div>
                                            <input
                                                type="checkbox"
                                                checked={bChecked}
                                                onChange={(aEvent) =>
                                                {
                                                    this.handleChange(aEvent, {
                                                        sType: sType,
                                                        bIsModelObj: bIsModelObj,
                                                        direction: aValue.sType === "REL" && (aValue.isIncomingRel ? "INCOMING" : "OUTGOING"),
                                                        list: aValue.sType === "REL" ? true:false,
                                                        ctrlType: aValue.ctrlType
                                                    });

                                                    if (onChangeCallback && typeof onChangeCallback === 'function')
                                                    {
                                                        onChangeCallback();
                                                    }
                                                }}
                                                name={sName}
                                            />
                                            <label>
                                                <Highlighter
                                                    highlightStyle={{ background: "#FFFF00" }}
                                                    textToHighlight={sLabel}
                                                    searchWords={[sSearchInput]}
                                                    autoEscape={true}
                                                />
                                            </label>
                                        </div>
                                    );
                                } else
                                {
                                    return (
                                        <div>
                                            {sIcon && <img src={"data:image/png;base64," + sIcon} />}
                                            {' '}
                                            <span>{sLabel}</span>
                                        </div>
                                    );
                                }
                            }}
                            valueRenderer={(sStringValue, aValue, ...keyPath) =>
                            {
                                const sRelNameFromPath = keyPath[0];
                                keyPath.reverse();
                                const aKeyPathReversed = JSON.parse(JSON.stringify(keyPath));
                                keyPath.reverse();
                                const aInitValue = ObjectPath.get(this.props.aNotebook, aKeyPathReversed);

                                if (aInitValue.hasOwnProperty("direction"))
                                {
                                    return (
                                        <div>
                                            <button className="wrcButton wrcButton--medium wrcButton--medium--object" onClick={() =>
                                            {
                                                const aModalData = JsonTreeCommons.getDataForRelationModal({
                                                    data: aInitValue,
                                                });

                                                // StateGlobal._currentBradCrumbs.push(sRelNameFromPath);

                                                this.aModalRel.current.setTargetClasssesNotebooks(aModalData.targetNotebooks.classes);
                                                this.aModalRel.current.setTargetModeltypesNotebooks(aModalData.targetNotebooks.modeltypes);
                                                this.aModalRel.current.setNotebook(aModalData.relNotebook);
                                                this.aModalRel.current.setDirection(aInitValue.direction);
                                                this.aModalRel.current.setRelationName(aInitValue.sName);

                                                this.aModalRel.current.toggleModal();

                                                aModalData.modelID.forEach((el) => {
                                                    var aMetaModelTypeData = MetamodelStore.getInstance().getMetaModelType(el);
                                                    this.state.allModels.push(aMetaModelTypeData.aDisplayName[Config.lang.selected])

                                                    aMetaModelTypeData.classes.forEach((classes) => {
                                                        const exists = this.state.allObjects.some(obj => obj === classes);
                                                        if (!exists) {
                                                            this.state.allObjects.push(classes);
                                                        }
                                                    });
                                                });

                                            }
                                            }>
                                                {Config.strings.jsonTree.buttons.insertRelData}
                                            </button>
                                        </div>
                                    );
                                }
                                return null;
                            }
                            }
                        />
                        <ModalRelationData
                            ref={this.aModalRel}
                            titleNotebook={Config.strings.modals.relationData.sTitleNotebook}
                            titleClasses={Config.strings.modals.relationData.sTitleClasses}
                            titleModeltypes={Config.strings.modals.relationData.sTitleModeltypes}
                            innerLoop={bIsModelObj}
                            selectionCallback={this.getRelationSelection}
                            isFilter={true}
                            preventRelationNotebook={bPreventRelationNotebook}
                            pairModeAllowed={true}
                            allObjects={this.state.allObjects}
                            allModels={this.state.allModels}
                            hideLoop={true}
                        />
                    </div>}
            </div >
        );
    }
}
